/* eslint-disable max-len */
import * as Constants from './constants';

export const questionRequest = filters => ({
  type: Constants.QUESTION_REQUEST,
  filters
})
export const questionSuccess = data => ({
  type: Constants.QUESTION_SUCCESS,
  data,
})
export const questionError = error => ({
  type: Constants.QUESTION_ERROR,
  error,
})

export const filterRequest = () => ({
  type: Constants.FILTER_REQUEST,
})
export const filterSuccess = data => ({
  type: Constants.FILTER_SUCCESS,
  data,
})
export const filterError = error => ({
  type: Constants.FILTER_ERROR,
  error,
})

export const deleteRequest = (id, filters) => ({
  type: Constants.DELETE_REQUEST,
  id,
  filters,
})
export const deleteSuccess = result => ({
  type: Constants.DELETE_SUCCESS,
  result,
})
export const deleteError = error => ({
  type: Constants.DELETE_ERROR,
  error,
})

export const clearDeleteRequest = () => ({
  type: Constants.CLEAR_DELETE_REQUEST
})
